import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'

function Header() {
    const dropdownMenuRef = useRef(null);
    
        const handleMouseEnter = () => {
          if (dropdownMenuRef.current) {
            dropdownMenuRef.current.classList.add("show", "fade-down"); // Optionally add your custom class
          }
        };
        
        const handleMouseLeave = () => {
          if (dropdownMenuRef.current) {
            dropdownMenuRef.current.classList.remove("show", "fade-down");
          }
        };
        
    
        useEffect(() => {
            localStorage.removeItem("user");
        }, []);
  return (
   <>
   <nav className="navbar navbar-expand-lg py-lg-3 navbar-dark">
                   <div className="container">
                       <Link className="navbar-brand me-lg-5">
                           <img
                               src="assets/images/logo.png"
                               alt="logo"
                               className="logo-dark"
                               height={30}
                           />
                       </Link>
                       <button
                           className="navbar-toggler"
                           type="button"
                           data-bs-toggle="collapse"
                           data-bs-target="#navbarNavDropdown"
                           aria-controls="navbarNavDropdown"
                           aria-expanded="false"
                           aria-label="Toggle navigation"
                       >
                           <i className="mdi mdi-menu" />
                       </button>
                       <div className="collapse navbar-collapse" id="navbarNavDropdown">
                           <ul className="navbar-nav me-auto align-items-center">
                               <li className="nav-item mx-lg-1">
                                   <Link to="/" className="nav-link" href="#">
                                       Home
                                   </Link>
                               </li>
                               <li className="nav-item mx-lg-1">
                                   <Link to="/about" className="nav-link">
                                       About
                                   </Link>
                               </li>
                               {/* Service Dropdown */}
                               <li
                                   className="nav-item dropdown mx-lg-1"
                                   onMouseEnter={handleMouseEnter}
                                   onMouseLeave={handleMouseLeave}
                               >
                                   <Link
                                       to="/service"
                                       className="nav-link dropdown-toggle"
                                       id="dropdownMenuButton"
                                       aria-haspopup="true"
                                       aria-expanded="false"
                                   >
                                       Service
                                   </Link>
                                   <div
                                       className="bg-primary dropdown-menu"
                                       ref={dropdownMenuRef}
                                       aria-labelledby="dropdownMenuButton"
                                   >
                                       <Link to="/creditcardservice" className="nav-link">
                                           Credit Card
                                       </Link>
                                       <Link to="/loanservice" className="nav-link">
                                           Loan
                                       </Link>
                                       <Link to="/insuranceservice" className="nav-link">
                                           Insurance
                                       </Link>
                                       <Link to="/creditcardswipeservice" className="nav-link">
                                           Credit Card Swipe
                                       </Link>
                                       <Link to="/passportservicesservice" className="nav-link">
                                           Passport Services
                                       </Link>
                                       <Link to="/pancardServices" className="nav-link">
                                           Pan Card Services
                                       </Link>
                                       <Link to="/udhyamservice" className="nav-link">
                                           Udhyam
                                       </Link>
                                       <Link to="/voterIDcardservice" className="nav-link">
                                           Voter ID Card
                                       </Link>
                                       <Link to="/incometaxservicesservice" className="nav-link">
                                           Income Tax Services
                                       </Link>
                                       <Link to="/e-shramservice" className="nav-link">
                                           E-shram
                                       </Link>
                                       
   
                                   </div>
                               </li>
                               <li className="nav-item mx-lg-1">
                                   <Link to="/team" className="nav-link">
                                       Team
                                   </Link>
                               </li>
                               <li className="nav-item mx-lg-1">
                                   <Link to="/contact" className="nav-link">
                                       Contact
                                   </Link>
                               </li>
                           </ul>
                           <ul className="navbar-nav ms-auto align-items-center">
                               <li className="nav-item me-0">
                                   <Link to="/login" className="nav-link d-lg-none">
                                       Login
                                   </Link>
                                   <Link
                                       to="/login"
                                       className="btn btn-sm btn-light rounded-pill d-none d-lg-inline-flex"
                                   >
                                       <i className="mdi mdi-login me-2" /> Login
                                   </Link>
                               </li>
                           </ul>
                       </div>
                   </div>
               </nav>
   </>
  )
}

export default Header
